import { render } from "./sku_wise_sale.vue?vue&type=template&id=50366a6c&scoped=true"
import script from "./sku_wise_sale.vue?vue&type=script&lang=js"
export * from "./sku_wise_sale.vue?vue&type=script&lang=js"

import "./sku_wise_sale.vue?vue&type=style&index=0&id=50366a6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50366a6c"]])

export default __exports__